var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBridgeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26.5H23.5V5.5H26.5V26.5ZM31.5 18.05C30.3 16.65 29.3 15.05 28.5 13.4V26.5H31.5V18.05ZM36.5 22.35C35.45 21.7 34.45 20.95 33.5 20.1V26.5H36.5V22.35ZM11.5 23.45C9.95 24.2 8.25 24.75 6.5 25.1V26.5H11.5V23.45ZM21.5 13.4C20.7 15.1 19.7 16.65 18.5 18.05V26.5H21.5V13.4ZM38.5 23.45V26.5H43.5V25.1C41.75 24.8 40.05 24.2 38.5 23.45ZM16.5 20.1C15.55 20.95 14.55 21.7 13.5 22.35V26.5H16.5V20.1ZM6.5 31.6C8.8 32.05 10.5 34.1 10.5 36.5V44.5H13.5V36.5C13.5 33.75 15.75 31.5 18.5 31.5C21.25 31.5 23.5 33.75 23.5 36.5V44.5H26.5V36.5C26.5 33.75 28.75 31.5 31.5 31.5C34.25 31.5 36.5 33.75 36.5 36.5V44.5H39.5V36.5C39.5 34.1 41.2 32.05 43.5 31.6V28.5H6.5V31.6Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeicon);
export default __webpack_public_path__ + "static/media/bridgeicon.5a462c53ebdd8f3cfe3c802ac74f6cf7.svg";
export { ForwardRef as ReactComponent };